import styled from 'styled-components';
import { Tag } from 'antd';

export const StatusTag = styled(Tag)`
  width: 84px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  svg {
    margin-right: 4px;
  }
`;

export const ImpressionFooter = styled.div`
  margin-left: 6px;
  font-size: 12px;
  svg {
    margin-right: 4px;
    font-size: 14px;
  }
`;
